module.exports = __webpack_public_path__ + "img/AF.84de2c4b.svg";